<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-grid">
        <div class="footer-column">
          <h3>Company</h3>
          <nav>
            <a href="#">About Us</a>
            <a href="#">Careers</a>
            <a href="#">Blog</a>
          </nav>
        </div>

        <div class="footer-column">
          <h3>Social</h3>
          <nav class="social">
            <a href="#">Facebook</a>
            <a href="#">Twitter</a>
            <a href="#">LinkedIn</a>
          </nav>
        </div>

        <div class="footer-column">
          <h3>Legal</h3>
          <nav>
            <a href="#">Impressum</a>
            <a href="#">Datenschutz</a>
            <a href="#">AGB's</a>
          </nav>
        </div>

        <div class="footer-column logo-column">
          <div class="logo">EasyRight</div>
        </div>
      </div>
      <p class="copyright">© 2025 EasyRight. Alle Rechte vorbehalten.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
.footer {
  margin-top: 100px;
  background: #333;
  color: #fff;
  padding: 40px 20px;
}

.footer-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  text-align: left;
}

.footer-column h3 {
  font-size: 18px;
  margin-bottom: 15px;
}

.footer-column nav a {
  color: #fff;
  text-decoration: none;
  display: block;
  margin-bottom: 10px;
  font-size: 16px;
  transition: color 0.3s ease;
}

.footer-column nav a:hover {
  color: #00aaff;
}

.logo-column {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  font-size: 28px;
  font-weight: bold;
}

footer p {
  font-size: 14px;
  margin-top: 20px;
  text-align: center;
}
</style>
